import { put } from 'redux-saga/effects'
import importer from 'common/importer'
/* ACTIONS */
const UserActions = importer('Stores/Users/Actions')
/* ENDPOINT */
const { loginFlow } = importer('APIs/auth', null)
const { loginCallTwoUrl } = loginFlow
export default function * main ({ sessionToken }) {
  try {
    yield put(UserActions.loginAuthLoading())
    const res = yield loginCallTwoUrl(sessionToken)
    yield put(UserActions.loginAuthSuccess(res))
  } catch (error) {
    yield put(UserActions.loginAuthFailure(error))
  }
}
